export default {
  AI_PANEL_ANALYZE_QUESTION: 'AI_PANEL_ANALYZE_QUESTION',
  AUDIO_STOP: 'AUDIO_STOP'
}; 